import { Layout } from "./Layout";

export const ContactUs = () => {
  return (
    <Layout>
      <div
        className={`bg-white/5 rounded-lg px-7 py-10 verify-bg flex items-center justify-center h-64 mb-10`}
      >
        <div className="flex flex-col gap-y-4 items-center">
          {
            <>
              <h2 className="font-bold text-2xl">تماس با ما</h2>
              <p className="opacity-50 max-w-md">
                برای تماس با ما میتوانید از آیکن پایین سمت راست صفحه استفاده
                کنید.
              </p>
            </>
          }
        </div>
      </div>
    </Layout>
  );
};
